module.exports = __webpack_public_path__ + "ffe50a712cd772cb5248bb30fee9d931.MP3";